import { create } from 'zustand';
import type { BlazeStatusDTO } from '@clanfire/shared';
import { blazeApi } from '@/api/endpoints';
import { useAuth } from './auth';

/** The Blaze page's status: fetched when it opens, and again whenever the server says it changed. */
interface BlazeState {
  status: BlazeStatusDTO | null;
  refresh: () => Promise<BlazeStatusDTO | null>;
  set: (status: BlazeStatusDTO) => void;
  reset: () => void;
}

export const useBlaze = create<BlazeState>((set) => ({
  status: null,
  refresh: async () => {
    try {
      const status = await blazeApi.status();
      set({ status });
      return status;
    } catch {
      return null;
    }
  },
  set: (status) => set({ status }),
  reset: () => set({ status: null }),
}));

/** Whether you have Blaze right now. */
export function useHasBlaze(): boolean {
  return useAuth((s) => !!s.user?.blazeUntil && new Date(s.user.blazeUntil).getTime() > Date.now());
}

export const hasBlazeNow = () => {
  const until = useAuth.getState().user?.blazeUntil;
  return !!until && new Date(until).getTime() > Date.now();
};
